import React from 'react';
import {injectStripe} from 'react-stripe-elements';
import {CardElement} from 'react-stripe-elements';
import {StyledButton, InlineError, P, H4} from '../../Typeset';
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";


class TransferCheckoutForm extends React.Component {
  state = {
    error: '',
    isLoading: false,
  };

  handleSubmit = (ev) => {
    ev.preventDefault();
    this.setState({error: '', isLoading: true});
    this.props.stripe.handleCardPayment(
      this.props.clientIntentClientSecret,
    ).then((response) => {
      if (response.error) {
        this.setState({error: response.error.message, isLoading: false});
      } else if (response.paymentIntent && response.paymentIntent.status === 'succeeded') {
        this.props.onSuccess({paymentId: response.paymentIntent.id});
      }
    });
  };

  render() {
    return (
      <form onSubmit={this.handleSubmit}>
        <div style={{
          marginBottom: 20,
          color: 'rgba(255, 255, 255, 0.85)'
        }}>
          <div style={{
            fontSize: '0.8rem',
            marginBottom: 6
          }}>Card details:</div>
          <CardElement hidePostalCode style={{
            base: {
              fontSize: '14px',
              fontFamily: 'Montserrat, Roboto, "Helvetica Neue", Arial',
              fontSmoothing: 'antialiased'
            },
            invalid: {
              color: '#9e2146',
            },
          }} />
        </div>
        {this.state.error && <InlineError>{this.state.error}</InlineError>}
        <div style={{display: 'flex', paddingBottom: '16px'}}>
          <Button style={{color: 'white', marginRight: 16}} size="small" onClick={this.props.onCancel}>
            Cancel
          </Button>
          <StyledButton type="submit" disabled={this.state.isLoading}>
            {this.state.isLoading ? <>
              Please wait...&nbsp;&nbsp;<CircularProgress style={{color: 'white'}} size={24} />
            </> : `Pay ${this.props.price_str}`}
          </StyledButton>
        </div>
      </form>
    );
  }
}

export default injectStripe(TransferCheckoutForm);
